// Anabolic Surge — Bloodwork Analysis Platform
// Operated by Arah Capital Group LLC

// ============================================
// SITE IMAGES — Editorial Bloodwork / Performance
// ============================================
export const siteImages = {
  heroMain:        'https://images.pexels.com/photos/3908178/pexels-photo-3908178.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400',
  heroSecondary:   'https://images.unsplash.com/photo-1543870080-e784fe86d173?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  laboratory:      'https://images.pexels.com/photos/3908179/pexels-photo-3908179.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  athlete:         'https://images.unsplash.com/photo-1470468969717-61d5d54fd036?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  analytics:       'https://images.unsplash.com/photo-1660970781103-ba6749cb9ce3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  labCorp:         'https://images.unsplash.com/photo-1570723989345-3a537f60a9c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  // Page banners
  aboutBanner:     'https://images.pexels.com/photos/3908178/pexels-photo-3908178.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1920',
  contactBanner:   'https://images.unsplash.com/photo-1660970781103-ba6749cb9ce3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  pricingBanner:   'https://images.pexels.com/photos/3908179/pexels-photo-3908179.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1920',
};

export const CURRENCY = 'USD';
export const COUNTRY_OF_ORIGIN = 'United States';

// Contact Info — Anabolic Surge
export const CONTACT_INFO = {
  phone: '(833) 439-3494',
  email: 'contactus@anabolicsurge.com',
  address: {
    street: '1331 W Haddington Ct',
    city: 'Palatine',
    state: 'IL',
    zip: '60067-6616',
    country: 'United States'
  },
  corporateName: 'Arah Capital Group LLC'
};

// Brand Info
export const BRAND_INFO = {
  name: 'Anabolic Surge',
  tagline: 'Bloodwork, rebuilt for clarity.',
  domain: 'anabolicsurge.com',
  billingDescriptor: 'ANABOLICSURGE.COM'
};

// ============================================
// LAB PANELS — Shop
// ============================================
export const LAB_PANELS = [
  {
    id: 'baseline',
    name: 'Baseline Performance Panel',
    price: 119,
    sku: 'AS-BASE',
    badge: '50+ MORE MARKERS',
    description: 'A focused starter draw covering the markers most lifters and endurance athletes ask about first. A clean baseline you can compare every future draw against.',
    bullets: ['Total Testosterone', 'Free Testosterone', 'FSH & LH', 'Lipid panel'],
    long: ['Comprehensive Metabolic Panel', 'Complete Blood Count w/ differential', 'TSH (thyroid stimulating hormone)', 'Hemoglobin A1c', 'hs-CRP (inflammation)']
  },
  {
    id: 'baseline-women',
    name: 'Baseline Panel — Women\u2019s Edition',
    price: 119,
    sku: 'AS-BASE-W',
    badge: '50+ MORE MARKERS',
    description: 'A women\u2019s-specific starting draw built around training, recovery, and menstrual hormone awareness — without the bloated extras you don\u2019t need.',
    bullets: ['Testosterone, Free and Total', 'Estradiol', 'Progesterone', 'Comprehensive Metabolic Panel'],
    long: ['Complete Blood Count w/ diff', 'TSH + Free T3 & Free T4', 'Lipid panel', 'Ferritin & iron panel']
  },
  {
    id: 'cycle-safety',
    name: 'Cycle Safety Scan',
    price: 99,
    sku: 'AS-CSS',
    badge: '20+ MARKERS',
    description: 'A targeted on-cycle and post-cycle safety check. Built to flag the categories most likely to drift when you are running anything: hormones, lipids, glucose handling, and liver/kidney load.',
    bullets: ['Total & Free Testosterone', 'Estradiol (sensitive)', 'HbA1c & glucose', 'Full lipid panel'],
    long: ['Liver enzymes (ALT / AST / ALP)', 'Kidney function (BUN / creatinine / eGFR)', 'CBC w/ hematocrit', 'Prolactin']
  },
  {
    id: 'complete-men',
    name: 'Complete Men\u2019s Panel',
    price: 239,
    sku: 'AS-CMP-M',
    badge: '80+ MARKERS',
    description: 'Everything in the Baseline Panel plus deeper hormone resolution and growth markers. A serious, recurring panel for athletes who treat lab work like a training log.',
    bullets: ['Everything in Baseline Panel', 'Ultrasensitive hormone testing', 'Insulin-Like Growth Factor 1 (IGF-1)', 'And more'],
    long: ['Sex Hormone Binding Globulin (SHBG)', 'DHEA-Sulfate', 'Cortisol AM', 'ApoB & Lipoprotein(a)', 'In-depth iron and ferritin']
  },
  {
    id: 'complete-women',
    name: 'Complete Women\u2019s Panel',
    price: 249,
    sku: 'AS-CMP-W',
    badge: '80+ MARKERS',
    description: 'Everything in the Baseline Women\u2019s Panel plus advanced iron, thyroid, and lipid resolution. A recurring panel for women dialing in training, recovery, and long-term health.',
    bullets: ['Everything in Baseline Women\u2019s Panel', 'Advanced iron markers', 'Thyroid screening', 'In-depth lipid testing'],
    long: ['Anti-thyroid antibodies', 'SHBG and Bioavailable testosterone', 'ApoB and Lp(a)', 'Vitamin D 25-OH', 'B12 and folate']
  },
  {
    id: 'pcos',
    name: 'Hormone Clarity \u2014 PCOS Edition',
    price: 645,
    sku: 'AS-PCOS',
    badge: '20+ MARKERS',
    description: 'A focused workup for women navigating PCOS questions: insulin resistance, androgen dominance, and the metabolic markers tied to both. Built to be informative, not exhaustive.',
    bullets: ['Total & Free Testosterone', 'Estradiol & Progesterone', 'HbA1c & fasting insulin', 'Full lipid panel'],
    long: ['DHEA-Sulfate', 'LH/FSH ratio', 'SHBG', 'Free Androgen Index', 'TSH & Free T4']
  },
  {
    id: 'thyroid',
    name: 'Full Thyroid Workup',
    price: 149,
    sku: 'AS-THY',
    badge: '12 MARKERS',
    description: 'A thyroid-focused draw for athletes who suspect their training fatigue or weight changes are downstream of a sluggish or overactive thyroid.',
    bullets: ['TSH', 'Free T3 & Free T4', 'Reverse T3', 'TPO & TG antibodies'],
    long: ['Total T3 & Total T4', 'Thyroglobulin', 'Selenium', 'Iron panel']
  },
  {
    id: 'recovery',
    name: 'Recovery & Inflammation Panel',
    price: 169,
    sku: 'AS-REC',
    badge: '25+ MARKERS',
    description: 'A recovery-oriented draw for athletes pushing hard volume. Inflammation, cortisol, iron stores, and the metabolic context around them \u2014 in one tidy slip.',
    bullets: ['hs-CRP & ferritin', 'Cortisol AM', 'CK (creatine kinase)', 'Comprehensive metabolic panel'],
    long: ['Vitamin D 25-OH', 'Magnesium', 'Iron / TIBC / saturation', 'Homocysteine']
  }
];

// ============================================
// BIOMARKERS — Build à la carte
// ============================================
export const BIOMARKERS = [
  { id: 'tt',     name: 'Total Testosterone',         price: 19, category: 'Sex hormones' },
  { id: 'ft',     name: 'Free Testosterone',          price: 29, category: 'Sex hormones' },
  { id: 'e2',     name: 'Estradiol (sensitive)',      price: 39, category: 'Sex hormones' },
  { id: 'shbg',   name: 'SHBG',                       price: 19, category: 'Sex hormones' },
  { id: 'prog',   name: 'Progesterone',               price: 24, category: 'Sex hormones' },
  { id: 'lh',     name: 'LH',                         price: 19, category: 'Sex hormones' },
  { id: 'fsh',    name: 'FSH',                        price: 19, category: 'Sex hormones' },
  { id: 'prl',    name: 'Prolactin',                  price: 19, category: 'Sex hormones' },
  { id: 'dhea',   name: 'DHEA-Sulfate',               price: 24, category: 'Sex hormones' },
  { id: 'igf1',   name: 'IGF-1',                      price: 59, category: 'Growth & metabolic' },
  { id: 'cort',   name: 'Cortisol, AM',               price: 22, category: 'Growth & metabolic' },
  { id: 'insul',  name: 'Fasting Insulin',            price: 24, category: 'Growth & metabolic' },
  { id: 'a1c',    name: 'Hemoglobin A1c',             price: 15, category: 'Growth & metabolic' },
  { id: 'gluc',   name: 'Fasting Glucose',            price: 9,  category: 'Growth & metabolic' },
  { id: 'apob',   name: 'ApoB',                       price: 24, category: 'Lipids' },
  { id: 'lpa',    name: 'Lipoprotein(a)',             price: 29, category: 'Lipids' },
  { id: 'ldl',    name: 'LDL Cholesterol',            price: 12, category: 'Lipids' },
  { id: 'hdl',    name: 'HDL Cholesterol',            price: 12, category: 'Lipids' },
  { id: 'tg',     name: 'Triglycerides',              price: 12, category: 'Lipids' },
  { id: 'crp',    name: 'hs-CRP',                     price: 19, category: 'Inflammation' },
  { id: 'homo',   name: 'Homocysteine',               price: 24, category: 'Inflammation' },
  { id: 'fer',    name: 'Ferritin',                   price: 14, category: 'Iron panel' },
  { id: 'iron',   name: 'Iron + TIBC',                price: 18, category: 'Iron panel' },
  { id: 'hgb',    name: 'Hemoglobin / Hematocrit',    price: 12, category: 'CBC' },
  { id: 'tsh',    name: 'TSH',                        price: 14, category: 'Thyroid' },
  { id: 'ft3',    name: 'Free T3',                    price: 19, category: 'Thyroid' },
  { id: 'ft4',    name: 'Free T4',                    price: 19, category: 'Thyroid' },
  { id: 'rt3',    name: 'Reverse T3',                 price: 39, category: 'Thyroid' },
  { id: 'vitd',   name: 'Vitamin D, 25-OH',           price: 22, category: 'Vitamins' },
  { id: 'b12',    name: 'Vitamin B12',                price: 14, category: 'Vitamins' },
  { id: 'fol',    name: 'Folate',                     price: 14, category: 'Vitamins' },
  { id: 'alt',    name: 'ALT (liver)',                price: 9,  category: 'Liver' },
  { id: 'ast',    name: 'AST (liver)',                price: 9,  category: 'Liver' },
  { id: 'alp',    name: 'Alkaline Phosphatase',       price: 9,  category: 'Liver' },
  { id: 'bun',    name: 'BUN (kidney)',               price: 9,  category: 'Kidney' },
  { id: 'creat',  name: 'Creatinine + eGFR',          price: 12, category: 'Kidney' },
  { id: 'mag',    name: 'Magnesium',                  price: 14, category: 'Other' },
  { id: 'ck',     name: 'Creatine Kinase (CK)',       price: 19, category: 'Other' },
];

// ============================================
// SAMPLE "YOUR LATEST DRAW" markers (for hero card)
// ============================================
export const SAMPLE_DRAW = [
  { name: 'Total Testosterone',     value: '842',  unit: 'ng/dL',  pct: 78 },
  { name: 'Estradiol (sensitive)',  value: '31',   unit: 'pg/mL',  pct: 62 },
  { name: 'SHBG',                   value: '24',   unit: 'nmol/L', pct: 28 },
  { name: 'ApoB',                   value: '89',   unit: 'mg/dL',  pct: 55 },
  { name: 'hs-CRP',                 value: '0.70', unit: 'mg/L',   pct: 42 },
  { name: 'Ferritin',               value: '186',  unit: 'ng/mL',  pct: 70 },
];

// ============================================
// MARKER GRID CATEGORIES
// ============================================
export const MARKER_CATEGORIES = [
  { name: 'Liver function',  count: 6 },
  { name: 'Metabolic',       count: 12 },
  { name: 'Lipids',          count: 9 },
  { name: 'Protein',         count: 5 },
  { name: 'Sex hormones',    count: 11 },
  { name: 'Thyroid',         count: 7 },
  { name: 'Inflammation',    count: 4 },
  { name: 'CBC',             count: 13 },
  { name: 'Iron panel',      count: 5 },
  { name: 'Vitamins',        count: 6 },
  { name: 'Kidney',          count: 5 },
  { name: 'Other',           count: 8 },
];

// ============================================
// PROCESS — Order to result
// ============================================
export const PROCESS_STEPS = [
  {
    step: '01',
    title: 'Order online',
    body: 'Pick a panel or build your own à la carte. The whole checkout takes about ninety seconds — no consultation booking, no portal hopping.'
  },
  {
    step: '02',
    title: 'Requisition emailed',
    body: 'Your lab slip lands in your inbox the moment you check out. Print it, save it, or just pull it up on your phone at the draw station.'
  },
  {
    step: '03',
    title: 'Get drawn',
    body: 'Walk in to any participating Quest, LabCorp, or BioReference location. Most draws take less than ten minutes from check-in to bandage.'
  },
  {
    step: '04',
    title: 'Results stream in',
    body: 'Markers populate live in your dashboard as the lab releases them — no waiting weeks for a single PDF report at the end.'
  }
];

// ============================================
// PLATFORM FEATURES
// ============================================
export const PLATFORM_FEATURES = [
  {
    id: 'timeline',
    title: 'Every marker, on one timeline',
    short: 'Every result you have ever drawn — across every panel — plotted on a single timeline. No more comparing PDF dates by hand.',
    description: 'We unify your draw history so you can finally answer the question that matters most: is this number trending up, down, or sideways? Inflection points get tagged automatically.'
  },
  {
    id: 'grid',
    title: '100+ marker grid at a glance',
    short: 'A single dense grid that shows where every result lands — in range, above, below, or still pending — so you know what to look at first.',
    description: 'Built for athletes who pull dozens of markers per draw. Skim the grid in five seconds and zoom into anything that flags itself.'
  },
  {
    id: 'upload',
    title: 'Bring your own labs',
    short: 'Already have PDFs from a prior draw? Upload them free. We currently parse LabCorp PDFs, with more lab formats actively being added.',
    description: 'Drop a PDF in. We extract every marker, normalize the units, and add it to your timeline alongside every other draw — all without re-typing a single value.'
  },
  {
    id: 'alacarte',
    title: 'Build à la carte',
    short: 'Browse 140+ markers with live, lab-verified pricing. Pick exactly what you care about and skip every marker you do not.',
    description: 'Hate paying for a panel that bundles fifty markers when you only wanted four? Build your own panel and pay marker by marker.'
  },
  {
    id: 'fast',
    title: 'From order to first result in under 48 hours',
    short: 'Most panels go from checkout to first markers in your dashboard the next day. The full panel typically lands inside two days.',
    description: 'Markers stream in as the lab releases them. You see the fast ones first — no artificial \u201chold the report until everything is in\u201d delays.'
  },
  {
    id: 'private',
    title: 'Your data, your account',
    short: 'Your dashboard is yours. We do not sell health data, we do not run health-data ads, and your panels stay tied to your account only.',
    description: 'Encrypted in transit, encrypted at rest. Export anything you have ever drawn as a clean CSV any time you want to take it with you.'
  }
];

// ============================================
// TESTIMONIALS
// ============================================
export const TESTIMONIALS = [
  { quote: 'Ordered on Friday, 50+ results back the next day.', author: 'John D.' },
  { quote: 'The charts alone are worth it.',                     author: 'Sarah M.' },
  { quote: 'Half the price of my last lab draw.',                author: 'Michael T.' },
  { quote: 'This company is underrated.',                        author: 'David L.' },
  { quote: 'Surprise — they don\u2019t charge anything to upload PDFs.', author: 'Emma R.' },
  { quote: 'Customer support is something you don\u2019t find in a lot of companies these days. These folks nailed it.', author: 'Alex K.' },
  { quote: 'I finally see what is actually moving over time.',   author: 'Priya S.' },
  { quote: 'Cheaper than my insurance copay was.',                author: 'Marcus J.' },
];

// ============================================
// FAQ
// ============================================
export const FAQS = [
  {
    q: 'Is Anabolic Surge a medical or diagnostic service?',
    a: 'No. Anabolic Surge is a health information and lab ordering platform. Your results are real lab-issued results, but our dashboards, ranges, and educational content are not a substitute for a clinician. Always discuss meaningful changes with a licensed healthcare professional.'
  },
  {
    q: 'Where do you actually run the labs?',
    a: 'We partner with major U.S. clinical lab networks (LabCorp, Quest Diagnostics, and BioReference where supported). When you check out, you choose a participating draw location near you, walk in with your requisition, and get drawn just like a normal lab visit.'
  },
  {
    q: 'How long until I see results?',
    a: 'Most panels deliver the first markers to your dashboard within twenty-four hours of the draw. Faster markers (CBC, basic chemistries) typically post first; longer-running assays (ultrasensitive estradiol, IGF-1) finish a day or two later.'
  },
  {
    q: 'Can I upload PDFs from a prior lab?',
    a: 'Yes — uploading PDFs is free. Right now we parse LabCorp PDFs reliably, with more lab formats being added on a rolling basis. Your uploaded markers appear on the same timeline as anything you order through us.'
  },
  {
    q: 'Do I need a doctor\u2019s order?',
    a: 'For the panels we sell directly, no separate doctor visit is needed — every requisition is reviewed and signed by a licensed independent physician on our partner network as part of your order.'
  },
  {
    q: 'How much does shipping or anything physical cost?',
    a: 'Nothing physical is shipped. Your requisition is delivered as a digital lab slip the moment you order. You get drawn at a participating Quest, LabCorp, or BioReference draw center near you.'
  },
  {
    q: 'Can I cancel a recurring panel subscription?',
    a: 'Yes — at any time. Cancel from inside your account under Account → Billing, or by emailing contactus@anabolicsurge.com. After you cancel, you keep access to your existing dashboard. Future panels simply will not be queued.'
  },
  {
    q: 'How do I get a refund?',
    a: 'If your draw was never completed, contact us at contactus@anabolicsurge.com or (833) 439-3494 within 30 days of your charge and we will issue a full refund. Once a draw has been processed by a partner lab, refunds follow the policy on our Refund page.'
  }
];

// ============================================
// HOMEPAGE TRUST STRIP
// ============================================
export const TRUST_STATS = [
  { value: '140+',     label: 'Markers available' },
  { value: '< 48 hrs', label: 'Avg. order to first result' },
  { value: '2,000+',   label: 'Draws processed' },
  { value: 'USA',      label: 'Operated from Illinois' },
];

// Backward compatibility shim — keep old export names alive so older pages
// (legal pages etc.) don\u2019t break while they get progressively rewritten.
export const FEATURES = PLATFORM_FEATURES;
export const HOW_IT_WORKS = PROCESS_STEPS;
export const PRICING_PLANS = LAB_PANELS;
export const QUIZ_STEPS = [];
